import ar from "./ar.json";
import en from "./en.json";

const locals = ["ar", "en"] as const;
type Locale = typeof locals[number];
const lSLocale = localStorage.getItem("locale") as Locale;
export const locale: Locale = locals.includes(lSLocale) ? lSLocale : "ar";

export const translation = locale === "ar" ? ar : en;
